import React from "react";
import { useSelector } from "react-redux";
import { selectWhiteListStatus } from "../../../redux/personaliseLessons/whiteListSlice";

const BenefitsOfCourse = () => {
  const whiteListUserStatus = useSelector(selectWhiteListStatus);

  const notInWhiteListUser =
    whiteListUserStatus?.message === "Email is not pre registered.";

  return (
    <div>
      <h2 className="mb-3 text-2xl font-semibold">Benefits Of This Course</h2>
      <div className="rounded-xl bg-[#2D4F71] p-3">
        <div className="mb-3 flex items-center rounded-xl bg-[#1D3854] p-3">
          <div className="mr-2 h-[50px] w-[55px]">
            <img
              src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Project_management_4.svg?updatedAt=1685516333321"
              alt=""
              className="h-full w-full"
            />
          </div>
          {notInWhiteListUser ? (
            <p className="leading-5">
              A stand-out portfolio with 4 new projects & a{" "}
              <span className="font-bold text-[#67CDEE]">
                93% better resume
              </span>
            </p>
          ) : (
            <p className="leading-5">
              A stand-out profile & a{" "}
              <span className="font-bold text-[#67CDEE]">
                93% better resume
              </span>
            </p>
          )}
        </div>
        <div className="mb-3 flex items-center rounded-xl bg-[#1D3854] p-3">
          <div className="mr-2 h-auto w-[60px]">
            <img
              src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Resume_3.svg?updatedAt=1685526433121"
              alt=""
              className="h-full w-full"
            />
          </div>
          <p className="leading-5">
            <span className="font-bold text-[#67CDEE]">
              3x higher chance of getting hired
            </span>{" "}
            with amazing skills & certification
          </p>
        </div>
        <div className="flex items-center rounded-xl bg-[#1D3854] p-3">
          <div className="mr-3 h-auto w-[50px]">
            <img
              src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Companies_1.svg?updatedAt=1685526534357"
              alt=""
              className="h-full w-full object-fill"
            />
          </div>
          <p className="leading-5">
            A chance to interview with our{" "}
            <span className="font-bold text-[#67CDEE]">
              900+ hiring partners
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default BenefitsOfCourse;
